import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
  selector: 'lib-pdf',
  standalone: true,
  imports: [FormsModule, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  <div class="pdf-container">
      @if (errors.noUrl) {
      <div class="error-message">No PDF to load.</div>

      } @else {

      @if (filename) {
      <div class="filename">{{ filename }}</div>
      }

      <object [data]="srcUrl" [name]="filename" type="application/pdf"></object>
      <!-- <iframe [src]="srcUrl" [name]="filename" type="application/pdf"></iframe> -->
      }
  </div>
  `,
  styleUrl: './pdf.component.scss',
})
export class PdfComponent {

  /**
   * The URL of the PDF to load.
   *
   * @type {(string | undefined)} The URL of the PDF to load.
   */
  private _srcUrl: string | undefined;

  /**
   * The URL of the PDF to load.
   * Utilizes Angular's DomSanitizer to bypass security and load the PDF.
   *
   * @type {SafeResourceUrl} The sanitized URL of the PDF to load.
   */
  public get srcUrl(): SafeResourceUrl {
    this.errors.noUrl = (!this._srcUrl);

    return this._srcUrl
      ? (this.sanitize ? this.sanitizer.bypassSecurityTrustResourceUrl(this._srcUrl) : this._srcUrl)
      : '';
  }

  /**
   * Set the raw URL of the PDF to load.
   */
  @Input()
  public set srcUrl(value: string | undefined) {
    this._srcUrl = value;
  }

  /**
   * Sanitize the url before loading.
   * This should never be disabled as it can lead to XSS vulnerabilities.
   * 
   * But if you're know what you're doing, go for it. It could be your lucky day.
   */
  @Input()
  public sanitize = true;

  /**
   * The filename of the PDF to display.
   */
  @Input()
  public filename = '';

  /**
   * Error flags for the component.
   */
  public errors = {
    noUrl: false
  };

  public sanitizer = inject(DomSanitizer);

}
